import firestore from "../../../firebase/firestore";

export default {
  async getInstallmentsGroupsByConsumerUnit({ commit }, consumer_unit_id) {
    let installments_groups = [];
    commit("setLoading", true);
    return firestore
      .collection("installments_group")
      .where("consumer_unit_id", "==", consumer_unit_id)
      .onSnapshot(async (res) => {
        const changes = res.docChanges();
        for (const [, change] of changes.entries()) {
          const { doc } = change;
          switch (change.type) {
            case "added": {
              const data = {
                id: doc.id,
                ...doc.data(),
              };
              installments_groups.push(data);
              break;
            }
            case "modified": {
              const data = {
                id: doc.id,
                ...doc.data(),
              };
              const i = installments_groups.findIndex((i) => i.id === doc.id);
              installments_groups[i] = data;
              break;
            }
            case "removed": {
              installments_groups = installments_groups.filter(
                (i) => i.id !== doc.id,
              );
              break;
            }
            default:
              break;
          }
        }
        for (let i = 0; i < installments_groups.length; i++) {
          if (installments_groups[i].status === "refused") {
            const debt_billing = await firestore
              .collection("debt_billing")
              .doc(installments_groups[i].charged_debt_billings[0])
              .get();
            installments_groups[i].debt_billing_transaction_message =
              debt_billing.data()?.transaction?.acquirer_response_message;
          }
          installments_groups[i].showBillings = false;
          installments_groups[i].showParcels = false;
        }

        const installmentsCancelled = installments_groups.filter(
          (billing) => billing.status === "canceled",
        );
        const installmentsPending = installments_groups.filter(
          (billing) => billing.status != "canceled",
        );

        installmentsPending.sort((a, b) => {
          return b.created_at - a.created_at;
        });

        installmentsCancelled.sort((a, b) => {
          return b.created_at - a.created_at;
        });

        installments_groups = [
          ...installmentsPending,
          ...installmentsCancelled,
        ];

        await commit("setInstallmentsGroups", installments_groups);
        await commit("setLoading", false);
        return installments_groups;
      });
  },

  async getInstallmentsGroupsByCustomerId({ commit }, customer_id) {
    let installments_groups = [];
    commit("setLoading", true);
    return firestore
      .collection("installments_group")
      .where("customer_id", "==", customer_id)
      .onSnapshot(async (res) => {
        const changes = res.docChanges();
        for (const [, change] of changes.entries()) {
          const { doc } = change;
          switch (change.type) {
            case "added": {
              const data = {
                id: doc.id,
                ...doc.data(),
              };
              installments_groups.push(data);
              break;
            }
            case "modified": {
              const data = {
                id: doc.id,
                ...doc.data(),
              };
              const i = installments_groups.findIndex((i) => i.id === doc.id);
              installments_groups[i] = data;
              break;
            }
            case "removed": {
              installments_groups = installments_groups.filter(
                (i) => i.id !== doc.id,
              );
              break;
            }
            default:
              break;
          }
        }
        for (let i = 0; i < installments_groups.length; i++) {
          if (installments_groups[i].status === "refused") {
            const debt_billing = await firestore
              .collection("debt_billing")
              .doc(installments_groups[i].charged_debt_billings[0])
              .get();
            installments_groups[i].debt_billing_transaction_message =
              debt_billing.data()?.transaction?.acquirer_response_message;
          }
          installments_groups[i].showBillings = false;
          installments_groups[i].showParcels = false;
        }
        await commit("setInstallmentsGroups", installments_groups);
        await commit("setLoading", false);
        return installments_groups;
      });
  },

  async getDebtBillingsByConsumerUnit({ commit }, consumer_unit_id) {
    let debt_billings = [];
    commit("setLoading", true);
    return (
      firestore
        .collection("debt_billing")
        .where("consumer_unit", "==", consumer_unit_id)
        // .orderBy('created_at', 'desc')
        .onSnapshot(async (res) => {
          const changes = res.docChanges();
          // eslint-disable-next-line no-unused-  rs
          for (const [, change] of changes.entries()) {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                debt_billings.push(data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                // eslint-disable-next-line no-shadow
                const i = debt_billings.findIndex((i) => i.id === doc.id);
                debt_billings[i] = data;
                // console.log('modified after splice2', debt_billings)
                break;
              }
              case "removed": {
                debt_billings = debt_billings.filter((i) => i.id !== doc.id);
                break;
              }
              default:
                break;
            }
          }
          await commit("setDebtBillings", debt_billings);
          await commit("setLoading", false);
          return debt_billings;
        })
    );
  },

  async getDebtBillingsByCustomerId({ commit }, customer_id) {
    let debt_billings = [];
    commit("setLoading", true);
    return firestore
      .collection("debt_billing")
      .where("customer_id", "==", customer_id)
      .onSnapshot(async (res) => {
        const changes = res.docChanges();
        for (const [, change] of changes.entries()) {
          const { doc } = change;
          switch (change.type) {
            case "added": {
              const data = {
                id: doc.id,
                ...doc.data(),
              };
              debt_billings.push(data);
              break;
            }
            case "modified": {
              const data = {
                id: doc.id,
                ...doc.data(),
              };
              const i = debt_billings.findIndex((i) => i.id === doc.id);
              debt_billings[i] = data;
              break;
            }
            case "removed": {
              debt_billings = debt_billings.filter((i) => i.id !== doc.id);
              break;
            }
            default:
              break;
          }
        }
        await commit("setDebtBillings", debt_billings);
        await commit("setLoading", false);
        return debt_billings;
      });
  },
};
